// extracted by mini-css-extract-plugin
module.exports = {"panel":"side-by-side-text_panel__07Z8T"};